import React, { useState } from 'react';
import { Button, Container, Tab, Tabs } from 'react-bootstrap';
import { CursoEditor, CursosList, GrupoManager } from '../../../common/cursos';
import { Curso } from '../../../../service/types/cursos.types';
import { UserService } from '../../../../service/users.service';

type Seleccion = { modo: 'lista' } | { modo: 'nuevo' } | { modo: 'editar'; curso: Curso };

export default function CursosAdmin() {
  const [seleccion, setSeleccion] = useState<Seleccion>({ modo: 'lista' });

  return (
    <Container fluid className="p-4">
      <h3>Gestión de Cursos</h3>
      <Tabs defaultActiveKey="cursos" className="mb-3">
        <Tab eventKey="cursos" title="Cursos">
          {seleccion.modo === 'lista' && (
            <CursosList
              onSelectCurso={(curso) => setSeleccion({ modo: 'editar', curso })}
              onCreateNew={() => setSeleccion({ modo: 'nuevo' })}
            />
          )}
          {seleccion.modo !== 'lista' && (
            <>
              <Button variant="link" className="ps-0 mb-2" onClick={() => setSeleccion({ modo: 'lista' })}>
                &larr; Volver a la lista de cursos
              </Button>
              <CursoEditor
                key={seleccion.modo === 'editar' ? seleccion.curso.id : 'nuevo'}
                cursoId={seleccion.modo === 'editar' ? seleccion.curso.id : undefined}
                initialValue={seleccion.modo === 'editar' ? seleccion.curso : undefined}
                fetchUsers={UserService.find}
              />
            </>
          )}
        </Tab>
        <Tab eventKey="grupos" title="Grupos">
          <GrupoManager fetchUsers={UserService.find} />
        </Tab>
      </Tabs>
      <br/>
      <br/>
      <br/>
    </Container>
  );
}
